// extracted by mini-css-extract-plugin
export default {"subtext":"cd8XoLzIj4agGw3PWvIs","tipwellText":"XIVj2yz2o3oh86dq2mmH"};